export default "__VITE_ASSET__e8c13f2b__"